import React from 'react';
import allCountries from 'country-region-data/data.json';
import { useLocalization } from '../Helpers/useLocalization';
import AddressSuggestInput from './AddressSuggestInput';

interface IRegionSelection {
    value?: string;
    country?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
    placeholder?: string;
}

const inputStyle: React.CSSProperties = {
    width: '100%',
    boxSizing: 'border-box',
    paddingLeft: '8px',
    paddingTop: '8px',
    paddingBottom: '8px',
    height: '32px',
    border: '1px solid rgb(96,94,92)',
    borderRadius: '2px',
};

const RegionSelector: React.FC<IRegionSelection> = (props) => {
    const L = useLocalization();

    const regionNames = React.useMemo(
        () => (allCountries.find(c => c.countryName === props.country)?.regions ?? []).map(r => r.name),
        [props.country]
    );

    const getSuggestions = React.useCallback((query: string) => {
        const q = query.toLowerCase();
        return regionNames.filter(r => r.toLowerCase().startsWith(q));
    }, [regionNames]);

    // No region data for this country — fall back to plain text input
    if (regionNames.length === 0) {
        return (
            <input
                disabled={props.disabled}
                placeholder={props.placeholder ?? ''}
                value={props.value ?? ''}
                onChange={(e) => props.onChange?.(e.target.value)}
                className='address-autosuggest-input'
                style={{ ...inputStyle, paddingRight: '8px' }}
            />
        );
    }

    return (
        <AddressSuggestInput
            value={props.value}
            disabled={props.disabled}
            placeholder={props.placeholder ?? L('localization_address_region_placeholder')}
            inputStyle={{ ...inputStyle, paddingRight: '28px' }}
            getSuggestions={getSuggestions}
            onChange={(next) => props.onChange?.(next)}
        />
    );
};

export default RegionSelector;
